import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

// Function to set the page title
function setPageTitle(to) {
  document.title = getPageTitle(to.meta.title)
}

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  try {
    const hasToken = getToken()
    if (hasToken) {
      if (to.path === '/login') {
        next({ path: '/' })
      } else {
        setPageTitle(to)
        next()
      }
    } else {
      // Avoid infinite redirect loop
      if (to.path !== '/login') {
        next(`/login?redirect=${to.path}`)
      } else {
        next()
      }
    }
  } catch (error) {
    console.error('Error getting token:', error)
    if (to.path !== '/login') {
      next(`/login?redirect=${to.path}`)
    } else {
      next()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
